import { HardwareType } from '../api/api-generated';
import { useGetAllTypesQuery } from '../api/api-hooks';

export const useAnalyzerSerialAutocomplete = () => {
  const { data: analyzerTypes } = useGetAllTypesQuery({});

  let RX48TypeId: string,
    RX4TypeId: string,
    RX416TypeId: string,
    RX4DNCTypeId: string;

  let RX48Type: HardwareType,
    RX4Type: HardwareType,
    RX416Type: HardwareType,
    RX4DNCType: HardwareType;

  if (analyzerTypes) {
    for (const type of analyzerTypes) {
      switch (type.typeName) {
        case 'LPT-3000RX4-4':
        case 'LPT-3000Rx4-4':
        case 'LPT-3000RX4':
          RX4TypeId = '' + type.id;
          RX4Type = type;
          break;
        case 'LPT-3000RX4-8':
        case 'LPT-3000Rx4-8':
          RX48TypeId = '' + type.id;
          RX48Type = type;
          break;
        case 'LPT-3000RX4-16':
        case 'LPT-3000Rx4-16':
          RX416TypeId = '' + type.id;
          RX416Type = type;
          break;
        case 'LPT-3000RX4-DNC':
        case 'LPT-3000Rx4-DNC':
          RX4DNCTypeId = '' + type.id;
          RX4DNCType = type;
      }
    }
  }

  return (name: string, value: string) => {
    if (name === 'serial') {
      if (value.startsWith('08') && RX48TypeId) {
        return { hardwareTypeId: RX48TypeId, hardwareType: RX48Type };
      } else if (value.startsWith('04') && RX4TypeId) {
        return { hardwareTypeId: RX4TypeId, hardwareType: RX4Type };
      } else if (value.startsWith('16') && RX416TypeId) {
        return { hardwareTypeId: RX416TypeId, hardwareType: RX416Type };
      } else if (value.startsWith('D4') && RX4DNCTypeId) {
        return { hardwareTypeId: RX4DNCTypeId, hardwareType: RX4DNCType };
      } else {
        return {};
      }
    } else {
      return {};
    }
  };
};
